'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { isCrmPropertiesField, shouldUseJsonField } from '../../utils/typeUtils';
import { getIsPropertyRequired, getModelName, getSchemaType, retrieveSchema } from '../../utils/schemaUtils';
import { getParamRowId } from '../../utils/idUtils';
import DescriptorBlock from './shared/DescriptorBlock';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import JSONInput from '../inputs/JSONInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class JsonField extends Component {
  constructor(props) {
    super(props);
    const schemaType = getSchemaType(this.props.schema);
    this.isCrmPropertiesField = isCrmPropertiesField(this.props.schema, schemaType, this.props.idSchema, this.props.name);
  }
  getValueOrExample() {
    const {
      formData,
      schema,
      idSchema
    } = this.props;
    let valueOrExample = {};
    if (this.isCrmPropertiesField) {
      valueOrExample = (formData || {}).properties;
    } else if (shouldUseJsonField(schema, idSchema.$id)) {
      valueOrExample = formData || {};
    }
    return valueOrExample;
  }
  getLabel() {
    const {
      label,
      schema
    } = this.props;
    if (this.isCrmPropertiesField) {
      return 'properties';
    } else if (label) {
      return label;
    }
    return getModelName(schema);
  }
  render() {
    const {
      collapsed,
      disabled,
      formData,
      idSchema,
      isAdditionalProperty,
      onChange,
      readOnly,
      registry,
      required,
      schemaGroup
    } = this.props;
    const {
      definitions,
      formContext
    } = registry;
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    const {
      description
    } = schema;
    return /*#__PURE__*/_jsx("div", {
      className: "params-row",
      "data-test-id": `schema-field-${getParamRowId(idSchema.$id)}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "params-pair",
        children: [/*#__PURE__*/_jsx(DescriptorBlock, {
          description: description,
          id: idSchema.$id,
          label: this.getLabel(),
          required: required || getIsPropertyRequired(schema, this.getLabel()),
          schema: schema,
          schemaGroup: schemaGroup,
          schemaTypeI18nKey: "types.object"
        }), /*#__PURE__*/_jsx("div", {
          className: "params-content",
          children: /*#__PURE__*/_jsx(CollapseFieldWrapper, {
            collapsed: collapsed,
            formData: this.isCrmPropertiesField ? (formData || {}).properties : formData || {},
            isAdditionalProperty: isAdditionalProperty,
            children: /*#__PURE__*/_jsx(JSONInput, {
              disabled: disabled,
              formContext: formContext,
              id: idSchema && idSchema.$id,
              onChange: onChange,
              readOnly: readOnly,
              required: required || getIsPropertyRequired(schema, this.getLabel()),
              schema: schema,
              value: this.getValueOrExample()
            })
          })
        })]
      })
    });
  }
}
JsonField.propTypes = {
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};